import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import GenesisFavoriteButton from '../core/GenesisFavoriteButton'
import { getSongLengthInSecondsFromMetadata } from '../core/Utils'

const GalleryListViewItem = ({ props, onClick, isSelected }) => {
  const [isFavorited, setIsFavorited] = React.useState(false)

  let song_length_seconds = getSongLengthInSecondsFromMetadata(props.metadata)
  let song_length_str =
    String(Math.floor(song_length_seconds / 60.0)) +
    ':' +
    String(Math.floor(song_length_seconds % 60)).padStart(2, '0')

  return (
    <div
      onDoubleClick={() => {
        onClick()
      }}
      className="row unselectable gallery-list-item"
      // style={isSelected ? { backgroundColor: '#222' } : {}}
    >
      <div className="d-flex col col-lg-6 px-3">
        <div className="pe-2">
          <a onClick={() => onClick()}>
            {isSelected ? (
              <img src="/static/icons/equalizer_arpeggi_blue_24dp.svg" />
            ) : (
              <img src="/static/icons/play_arrow_white_24dp.svg" />
            )}
          </a>
        </div>
        <div className="d-flex-column justify-content-center">
          <p className="mb-0 fw-semibold" style={{ color: isSelected && 'var(--arpeggi-blue)' }}>
            {props.metadata.title}
          </p>
          <Link className="" to={'/profile/' + String(props.metadata.address) + '/'}>
            <p className="underline-on-hover muted mb-0">{props.metadata.artist}</p>
          </Link>
        </div>
      </div>
      <div className="d-none d-md-flex col text-start me-2">
        <p className="muted my-auto">
          {moment.unix(props.metadata.mint_time).format('MMM D, YYYY')}
        </p>
      </div>
      <div className="d-inline-flex col justify-content-end text-end">
        <GenesisFavoriteButton
          className="col-6 col-lg-10 my-auto"
          favorite_count={props.favorite_count}
          white={true}
          width="20px"
          height="20px"
          song_id={props.song}
        />
        <p className="muted col-6 col-lg-2 my-auto">{song_length_str}</p>
      </div>
    </div>
  )
}

export const GalleryListView = ({ mintedSongs, setSelectedSong, selectedSong }) => {
  const [searchQuery, setSearchQuery] = React.useState('')

  return (
    <div>
      <div className="d-flex col-12 col-md-6 pb-4">
        <div className="search-bar-icon">
          <img src="/static/icons/search_white_24dp.svg" />
        </div>
        <input
          type="text"
          className="search-bar"
          placeholder={'Search by artist, song title...'}
          onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          value={searchQuery}
        />
      </div>
      <div className="w-100 d-flex justify-content-between" style={{ color: '#fff' }}>
        <div className="col col-lg-6">
          <p className="muted mb-1">Title</p>
        </div>
        <div className="d-none col d-md-block text-start" style={{ width: '70px' }}>
          <p className="muted mb-1">Date</p>
        </div>
        <div className="col text-end">
          <p className="muted pe-4 mb-1">Time</p>
        </div>
      </div>
      <hr style={{ color: 'white', marginTop: '5px', marginBottom: '5px' }} />
      <div className="container-fluid gallery-list-view mx-0 px-0">
        {mintedSongs.map((item, index) =>
          searchQuery === '' ||
          item.metadata.artist.toLowerCase().includes(searchQuery) ||
          item.metadata.title.toLowerCase().includes(searchQuery) ? (
            <GalleryListViewItem
              key={index}
              props={item}
              onClick={() => setSelectedSong(index)}
              isSelected={index === selectedSong}
            />
          ) : (
            <></>
          )
        )}
      </div>
      <hr style={{ color: 'white', marginTop: '5px', marginBottom: '5px' }} />
    </div>
  )
}
